import React, { useEffect } from "react";
import Breadchrumb from "../components/Breadchrumb";


const About = () => {
  useEffect(() => {
    document.title = "About JB Corporation | Leading Linear Motion Products Supplier in Ahmedabad Gujarat";
  }, []);
  return (
    <section className="about-page">

     <Breadchrumb pageName="About Us" />

      {/* ---------- COMPANY STORY ---------- */}
      <div className="about-page-container">
        <div className="about-page-content">
          <div className="about-text">
            <h2>Who We Are</h2>
            <p>
              JB Corporation is a leading industrial manufacturing company in Ahmedabad Gujarat India
              specializing in innovative and high-quality Linear Motion Products for diverse
              sectors. With years of experience, we are committed to providing
              reliable solutions that drive growth and efficiency.
            </p>
            <p>
              Our advanced infrastructure in Kathwada Ahmedabad, cutting-edge technology, and a
              dedicated team enable us to deliver excellence in every project we
              undertake. At JB Corporation, quality and customer satisfaction are
              our top priorities for Rack & Pinion, Ball Screws, and Linear Guides.
            </p>

            <div className="about-page-features">
              <div className="feature">
                <i className="fa-solid fa-industry"></i>
                <span>High-Quality Manufacturing</span>
              </div>
              <div className="feature">
                <i className="fa-solid fa-users"></i>
                <span>Skilled & Experienced Team</span>
              </div>
              <div className="feature">
                <i className="fa-solid fa-lightbulb"></i>
                <span>Innovative Engineering</span>
              </div>
              <div className="feature">
                <i className="fa-solid fa-shield-halved"></i>
                <span>Trusted Quality & Reliability</span>
              </div>
            </div>
          </div>
          <div className="about-page-image">
            <img src="/images/about/about.png" alt="About JB Corporation Ahmedabad Gujarat" title="JB Corporation Manufacturing Facility" />
          </div>
        </div>
      </div>

      {/* ---------- VISION & MISSION ---------- */}
      <div className="vision-mission">
        <div className="vm-box">
          <i className="fa-solid fa-eye"></i>
          <h3>Our Vision</h3>
          <p>
            To be recognized as a global leader in industrial innovation by
            consistently delivering world-class Linear Motion Products and services in Ahmedabad Gujarat.
          </p>
        </div>

        <div className="vm-box">
          <i className="fa-solid fa-bullseye"></i>
          <h3>Our Mission</h3>
          <p>
            To design and manufacture reliable Linear Motion solutions like Rack & Pinion and Ball Screws that empower businesses,
            enhance productivity, and inspire trust across industries in Kathwada Ahmedabad.
          </p>
        </div>
      </div>



    {/* ---------- INFRASTRUCTURE & CERTIFICATIONS ---------- */}
<div className="infrastructure-certifications">
  <div className="infra-container">
    {/* LEFT SIDE — IMAGE SHOWCASE */}
    <div className="infra-images">
      {/* <img src="/images/home/jb1.webp" alt="Factory Floor" /> */}
      <img src="/images/about/infrastructure1.png" alt="Machinery" />
      <img src="/images/about/infrastructure2.png" alt="Production Unit" />
    </div>

    {/* RIGHT SIDE — TEXT CONTENT */}
    <div className="infra-text">
      <h2>Our <span>Infrastructure</span></h2>
      <p>
        JB Corporation is equipped with a state-of-the-art manufacturing
        facility in Kathwada Ahmedabad Gujarat featuring advanced CNC machines, precision tools, and
        automated systems. Our infrastructure enables us to maintain strict
        quality control and timely delivery for every order of Linear Motion Components.
      </p>
      <p>
        Each production unit is optimized for efficiency, ensuring that every
        component we design meets international standards of quality and
        performance for Rack & Pinion, Ball Screws, and LM Guides.
      </p>

      <div className="certifications">
        <h3>Certifications & Quality Standards</h3>
        <div className="cert-list">
          <div className="cert-item">
            <i className="fa-solid fa-award"></i>
            <span>ISO 9001:2015 Certified</span>
          </div>
          <div className="cert-item">
            <i className="fa-solid fa-shield-halved"></i>
            <span>Premium Quality Assurance</span>
          </div>
          <div className="cert-item">
            <i className="fa-solid fa-industry"></i>
            <span>Modern Manufacturing Facility</span>
          </div>
          <div className="cert-item">
            <i className="fa-solid fa-people-group"></i>
            <span>Skilled & Experienced Workforce</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




      {/* ---------- CORE VALUES ---------- */}
      <div className="core-values">
        <h2>Our Core Values</h2>
        <div className="values-grid">
          <div className="value-item">
            <i className="fa-solid fa-lightbulb"></i>
            <h4>Innovation</h4>
            <p>We continuously evolve and adapt to deliver the most effective industrial Linear Motion solutions in Ahmedabad Gujarat.</p>
          </div>
          <div className="value-item">
            <i className="fa-solid fa-handshake"></i>
            <h4>Integrity</h4>
            <p>Honesty and transparency are the foundation of every client relationship.</p>
          </div>
          <div className="value-item">
            <i className="fa-solid fa-screwdriver-wrench"></i>
            <h4>Quality</h4>
            <p>We uphold the highest standards of manufacturing excellence in every Linear Motion product like Rack & Pinion and Ball Screws we create.</p>
          </div>
          <div className="value-item">
            <i className="fa-solid fa-users"></i>
            <h4>Teamwork</h4>
            <p>Our strength lies in collaboration — working together to achieve greatness.</p>
          </div>
        </div>
      </div>

    </section>
  );
};

export default About;
